import React from "react";
import "./AboutMe.scss";

export default function AboutMe() {
  return <div className="about-me">comming soon...</div>;
}
